import { BaseService } from "./BaseService";

const crearFormData = ({ nombre, descripcion, archivo }) => {
  const formData = new FormData();
  formData.append("nombre", nombre);
  formData.append("descripcion", descripcion || "");
  if (archivo) {
    formData.append("archivo", archivo);
  }
  return formData;
};

const DocumentoSolicitableService = {
  async listar() {
    const respuesta = await BaseService.get("/documentos-solicitables");
    return respuesta.data;
  },
  async buscarPorId(id) {
    const respuesta = await BaseService.get(`/documentos-solicitables/${id}`);
    return respuesta.data;
  },
  async insertar(datos) {
    const respuesta = await BaseService.post("/documentos-solicitables", crearFormData(datos), {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return respuesta.data;
  },
  async actualizar(id, datos) {
    const respuesta = await BaseService.put(`/documentos-solicitables/${id}`, crearFormData(datos), {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return respuesta.data;
  },
  async eliminar(id) {
    const respuesta = await BaseService.delete(`/documentos-solicitables/${id}`);
    return respuesta.data;
  },
};

export default DocumentoSolicitableService;
